import axios from "axios";


export const requiredChat = (
  setMessages,
  texts,
  setTexts,
  sessionId,
  setStatusMessage,
) => {
  setStatusMessage(true)
  if (!texts.trim()) return;

  setMessages((prev) => [
    ...prev,
    { sender: "Você", text: texts },
  ]);

  const body = {
    id: "100",
    question: texts,
    // session_id: sessionId,
    // language_code: "pt-BR",
  };

  axios
    .post("https://bot-dreamcoff-vertex.onrender.com/generate", body)
    .then((response) => {
      const botResponse = response.data.response;
      setMessages((prev) => [
        ...prev,
        { sender: "Assistente", text: botResponse },
      ]);
      setStatusMessage(false)
      setTexts("");
    })
    .catch((error) => {
      setStatusMessage(false)
      console.error("Erro ao buscar resposta:", error);
      setMessages((prev) => [
        ...prev,
        {
          sender: "Assistente",
          text: "Erro ao obter resposta. Tente novamente.",
        },
      ]);
    });
};
